import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

const Notifications = () => {
  return (
    <div className='page-container'>
        <div className='page-top-container'>
            <div className='page-header-title-container'>
                <NotificationsNoneOutlinedIcon/>
                <h1>Notificaties</h1>
            </div>
        </div>
    </div>
  )
}

export default Notifications